var a=(a,r="name")=>a?a.map((a=>r=>({id:r.id,value:String(r[a])}))(r)):[];export{a as extractFormData};
//# sourceMappingURL=extractFormData.js.map